export const RaceTypeLabels = {
    SEND_PACKET: 'Envio de paquetes',
    TAXI: 'Taxi',
    DELIVERY: 'Delivery',
    // OTHER: 'Otro'
};

export const RaceStateLabels = {
    // 'CREATED': 'Creado',
    // 'DELIVERED': 'Entregado'

    CREATED: 'Creada',
    ASSIGNED: 'Asignada',
    IN_PROGRESS: 'En progreso',
    DELIVERED: 'Entregada',
    CANCELLED: 'Cancelada'
};


// WEBPACK FOOTER //
// ./src/EnumsLabels.ts